
export const X_WWW_FORM = 'application/x-www-form-urlencoded'
export const JSON = 'application/json'
export const FORM_DATA = 'multipart/form-data'



// WEBPACK FOOTER //
// ./src/scripts/constants/RequestContentType.js